/**
 * Created by richard on 7/14/14.
 */
var spreadsheetModel = angular.module('spreadsheetModel', ['schoolModel']);
spreadsheetModel.factory('SpreadsheetModelFactory', function(ApplicationService, RestService, authServiceFactory, SchoolModelFactory, AbstractModelService){
    var SpreadsheetModel = function(){
        this.endpoint = "/spreadsheetDB";
        this.primaryKey = "recordID";
    }
    SpreadsheetModel.prototype = new SchoolModelFactory();
    SpreadsheetModel.prototype.parent = SchoolModelFactory.prototype;
    SpreadsheetModel.prototype.resolveData = function(schoolID)
    {
        var parent = this;
        return this.parent.resolveData.apply(this, arguments).then(function(data)
        {
            parent.data = data[0].data;
        });

    }
    SpreadsheetModel.prototype.new = function()
    {
        var schoolID = this.getSchoolID();
        return this.data.spreadsheets.push({
            schoolID: schoolID, spreadsheet: '', headers: '', name: '', type: '', year: 0
        }) - 1;
    }
    SpreadsheetModel.download = function(recordID)
    {

    }

    return SpreadsheetModel;
});


spreadsheetModel.service('SpreadsheetModelService', function(SpreadsheetModelFactory){
    var spreadsheetModel = new SpreadsheetModelFactory();
    return spreadsheetModel;
});


